import React from 'react';
import PropTypes from 'prop-types';
import { Trans } from 'lingui-react';

import { px2rem } from 'decisiv-ui-utils';
import { Row, Column } from 'styled-components-reactive-grid';
import { H2, P, QuickActionButton } from 'base-components';

import Modal from 'components/Modal';

/**
 * https://gist.github.com/ShirtlessKirk/2134376
 * Luhn algorithm in JavaScript: validate credit card number supplied as string of numbers
 * @author ShirtlessKirk. Copyright (c) 2012.
 * @license WTFPL (http://www.wtfpl.net/txt/copying)
 */
export const isCreditCardNumber = (arr => ccNum => {
  let len = ccNum.length;
  let bit = 1;
  let sum = 0;
  let val;

  while (len) {
    // eslint-disable-next-line no-plusplus
    val = parseInt(ccNum.charAt(--len), 10);
    // eslint-disable-next-line no-bitwise
    sum += (bit ^= 1) ? arr[val] : val;
  }

  return sum && sum % 10 === 0;
})([0, 2, 4, 6, 8, 1, 3, 5, 7, 9]);

const getNumberGroupMatches = str => str.match(/(?:\d{3,}[ -_]?){4}/gm) || [];
const cleanNumberGroup = str => str.replace(/[\D]/g, '');

export const containsCreditCardNumber = str =>
  getNumberGroupMatches(str).some(val =>
    isCreditCardNumber(cleanNumberGroup(val)),
  );

export const excludeCreditCardNumber = str => {
  const creditCards = getNumberGroupMatches(str).filter(val =>
    isCreditCardNumber(cleanNumberGroup(val)),
  );
  if (!creditCards.length) return str;
  const creditCardsReg = new RegExp(creditCards.join('|'), 'gm');
  return str.replace(creditCardsReg, '');
};

export function CreditCardComplianceModal({
  onDeleteCreditCardNumber,
  onContinue,
}) {
  return (
    <Modal onClose={() => {}}>
      {() => (
        <Modal.Body>
          <Modal.Header modifiers="warning">
            <Modal.HeaderIcon name="exclamation-triangle" />
          </Modal.Header>
          <Modal.Content>
            <Row modifiers="center" style={{ marginBottom: px2rem(20) }}>
              <Column>
                <H2 modifiers="fontWeightRegular">
                  <Trans>Recording a credit card number?</Trans>
                </H2>
              </Column>
            </Row>

            <Row modifiers="center" style={{ marginBottom: px2rem(20) }}>
              <Column modifiers={['col', 'padScaleX_5']}>
                <P modifiers="fontWeightRegular">
                  <Trans>
                    Oops... It looks like you&apos;re trying to record a credit
                    card number, which is not allowed. If this is not a credit
                    card number select &quot;Continue&quot; to proceed,
                    otherwise select &quot;Delete Credit Card Number&quot; to
                    delete this number from the field. Thanks for your
                    compliance with banking - credit regulations.
                  </Trans>
                </P>
              </Column>
            </Row>
          </Modal.Content>
          <Modal.Footer>
            <Row modifiers="end">
              <Column>
                <QuickActionButton onClick={onContinue} type="button">
                  <QuickActionButton.Text>
                    <Trans>Continue</Trans>
                  </QuickActionButton.Text>
                </QuickActionButton>
              </Column>
              <Column>
                <QuickActionButton
                  onClick={onDeleteCreditCardNumber}
                  type="button"
                  modifiers="secondary"
                >
                  <QuickActionButton.Text>
                    <Trans>Delete Credit Card Number</Trans>
                  </QuickActionButton.Text>
                </QuickActionButton>
              </Column>
            </Row>
          </Modal.Footer>
        </Modal.Body>
      )}
    </Modal>
  );
}

CreditCardComplianceModal.propTypes = {
  onDeleteCreditCardNumber: PropTypes.func.isRequired,
  onContinue: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/utils/creditCardNumberCompliance.js